import Vue from 'vue'
import { DashboardService,QuizService } from "@/common/api.service";
import { FETCH_DASHBOARD_DATA, FETCH_DASHBOARD_STATS_DATA,FETCH_TIME_DATA, FETCH_DASHBOARD_QUIZ_DATA ,FETCH_DASHBOARD_DOCUMENTS, FETCH_DASHBOARD_COURSE_QUIZ_DATA, FETCH_DASHBOARD_MODULE_QUIZ_DATA, FETCH_DASHBOARD_QUIZ_HISTORY_DATA, RESET_STATE } from "./actions.type";
import { SET_DASHBOARD_DATA, RESET_COURSES_DATA,SET_DASHBOARD_STATS_DATA, SET_SESSION_TIME_DATA, SET_DASHBOARD_COURSE_QUIZ  ,SET_DASHBOARD_DOCUMENTS, STATE_RESET } from "./mutations.type";

const initialState = () => {
    return {
        dashboarddocuments: {},
        dashboardcoursequizzes: {},
        coursesdata: [],
        timesessiondata:{},
        dashboardstats :[]
    }
}

let state = initialState()

const getters = {
    dashboarddocuments(state) {
        return state.dashboarddocuments
    },
    dashboardcoursequizzes(state) {
        return state.dashboardcoursequizzes
    },
    coursesdata(state) {
        return state.coursesdata
    },    
    timesessiondata(state) {
        return state.timesessiondata
    },  
    dashboardstats (state){
        return state.dashboardstats 
    }         
}

const actions = {
    async [FETCH_DASHBOARD_DATA](context, slug) {
        const { data } = await DashboardService.get(slug)
        context.commit(SET_DASHBOARD_DATA, data.data)
        return data;
    },
    async [FETCH_TIME_DATA](context, slug) {
        const { data } = await DashboardService.get('sessions?module_id='+slug.moduleid+'&user_id='+slug.userid+'&start_date='+slug.fromdate+'&end_date='+slug.todate)
        context.commit(SET_SESSION_TIME_DATA, {response: data.data, moduleindex: slug.moduleindex, course_id:slug.course_id})
        return data;
    },
    async [FETCH_DASHBOARD_QUIZ_HISTORY_DATA](context, slug) {
        if(slug.moduleid){
            const { data } = await DashboardService.get('quiz?module_id='+slug.moduleid+'&quiz_id='+slug.quiz_id)
            return data;
        }
        else{
            const { data } = await DashboardService.get('quiz?course_id='+slug.courseid+'&quiz_id='+slug.quiz_id)
            return data;
        }
    },
    async [FETCH_DASHBOARD_QUIZ_DATA](context, slug) {
        const { data } = await DashboardService.get('quiz?module_id='+slug.moduleid+'&user_id='+slug.userid+'&start_date='+slug.fromdate+'&end_date='+slug.todate)
        context.commit(SET_SESSION_TIME_DATA, {response: data.data, moduleindex: slug.moduleindex, course_id:slug.course_id})
        return data;
    },
    async [FETCH_DASHBOARD_COURSE_QUIZ_DATA](context, slug) {
        const { data } = await QuizService.get('?course_id='+slug.course_id)
        context.commit(SET_DASHBOARD_COURSE_QUIZ, {response: data.data, course_id:slug.course_id})
        return data;
    },
    async [FETCH_DASHBOARD_MODULE_QUIZ_DATA](context, slug) {
        const { data } = await QuizService.get('?module_id='+slug.moduleid)
        context.commit(SET_SESSION_TIME_DATA, {response: data.data, moduleindex: slug.moduleindex, course_id:slug.course_id})
        return data;
    },
    async [FETCH_DASHBOARD_DOCUMENTS](context, slug) {
        const { data } = await DashboardService.get('course-documents?course_id='+slug.course_id+'&search='+slug.search)
        context.commit(SET_DASHBOARD_DOCUMENTS, {response: data.data, course_id:slug.course_id})
        return data;
    },
    async [FETCH_DASHBOARD_STATS_DATA](context, slug) {
        const { data } = await DashboardService.get(slug)
        context.commit(SET_DASHBOARD_STATS_DATA, data.data)
        return data;
    },



    [RESET_STATE]({ commit }) {
        commit(STATE_RESET);
    }
}

const mutations = {
    [SET_SESSION_TIME_DATA](state, data) {
        if(state.timesessiondata.hasOwnProperty(data.course_id) == false){
            Vue.set(state.timesessiondata,data.course_id, {} )
        }
        Vue.set(state.timesessiondata[data.course_id],data.moduleindex, data.response )
    },
    [SET_DASHBOARD_COURSE_QUIZ](state, coursequizdata) {
        if(coursequizdata.response.length>0){
            Vue.set(state.dashboardcoursequizzes,coursequizdata.course_id, coursequizdata.response)
        }
    },
    [SET_DASHBOARD_DATA](state, coursesdata) {
        state.coursesdata = coursesdata
    },
    [SET_DASHBOARD_STATS_DATA](state, dashboarddata) {
        state.dashboardstats = dashboarddata
    },
    [SET_DASHBOARD_DOCUMENTS](state, documentsdata) {
        Vue.set(state.dashboarddocuments,documentsdata.course_id, documentsdata.response)
    },
    [RESET_COURSES_DATA](state){
        state.coursesdata = []
    },
    [STATE_RESET](state) {
        Object.assign(state, initialState())
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};
